module.exports = __webpack_public_path__ + "static/dog-37187f4659093d56af8a886035a02c51.png";